module.exports = __webpack_public_path__ + "img/hero-image.19288fb2.svg";